module.exports = __webpack_public_path__ + "static/MK3T5123-5e363c707842ae112f2c24da50336cfa.jpg";